import React from "react";
import { Truck, Navigation, CheckCircle2, Wrench } from "lucide-react";

const CFG = {
  on_the_way: { icon: Navigation, label: "Técnico a caminho", color: "text-sky-400", bg: "bg-sky-500/10", ring: "ring-sky-500/40", pulse: true },
  arrived: { icon: Truck, label: "Técnico chegou ao local", color: "text-emerald-400", bg: "bg-emerald-500/10", ring: "ring-emerald-500/40", pulse: false },
  working: { icon: Wrench, label: "Serviço em execução", color: "text-cyan-400", bg: "bg-cyan-500/10", ring: "ring-cyan-500/40", pulse: false },
};

export const TrackingBanner = ({ booking }) => {
  const st = booking?.tech_status;
  if (!st || st === "idle") return null;
  const cfg = CFG[st];
  if (!cfg) return null;
  const Icon = cfg.icon;
  const eta = booking.eta_minutes;

  return (
    <div className={`relative overflow-hidden rounded-xl ${cfg.bg} ring-1 ${cfg.ring} p-4 mb-4`} data-testid="tracking-banner">
      {cfg.pulse && <div className="absolute top-3 right-3 flex h-3 w-3">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-sky-400 opacity-75"></span>
        <span className="relative inline-flex h-3 w-3 rounded-full bg-sky-500"></span>
      </div>}
      <div className="flex items-start gap-3">
        <div className={`w-11 h-11 rounded-lg ${cfg.bg} flex items-center justify-center ring-1 ${cfg.ring}`}>
          <Icon className={`w-6 h-6 ${cfg.color}`} />
        </div>
        <div className="flex-1 min-w-0">
          <div className={`text-xs font-mono uppercase tracking-widest ${cfg.color}`}>Rastreio em tempo real</div>
          <div className="text-white font-bold text-base mt-0.5">{cfg.label}</div>
          {st === "on_the_way" && eta != null && (
            <div className="text-sm text-slate-300 mt-1">
              Chegada estimada: <strong className="text-white font-mono">{eta} min</strong>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
